import React, { useState, useEffect } from 'react';
import './ModelLoader.css';

/**
 * ModelLoader
 * Shows a full-panel loading animation while models initialise on the server.
 *
 * Props:
 *   mode        — 'detection' | 'transcription'
 *   onComplete  — called when the server reports ready
 *   onError     — called with an error string on failure
 */

const DETECTION_STAGES = [
  'Connecting to engine…',
  'Loading speech model…',
  'Initialising keyword detection…',
  'Calibrating detection pipeline…',
  'Ready.',
];

const TRANSCRIPTION_STAGES = [
  'Connecting to engine…',
  'Loading speech model…',
  'Initialising transcription pipeline…',
  'Calibrating voice activity detection…',
  'Ready.',
];

function ModelLoader({ mode = 'detection', onComplete, onError }) {
  const [stageIndex, setStageIndex] = useState(0);
  const stages = mode === 'transcription' ? TRANSCRIPTION_STAGES : DETECTION_STAGES;

  // Cycle through stage labels every ~2.5s (purely cosmetic — gives the user
  // a sense of progress while the real work happens on the server)
  useEffect(() => {
    if (stageIndex >= stages.length - 2) return; // leave last stage to onComplete
    const t = setTimeout(() => setStageIndex(i => i + 1), 2500);
    return () => clearTimeout(t);
  }, [stageIndex, stages.length]);

  return (
    <div className="ml-wrapper">
      <div className="ml-bars">
        {[1, 2, 3, 4, 5, 6, 7].map(i => (
          <div key={i} className={`ml-bar ml-bar-${i}`} />
        ))}
      </div>
      <p className="ml-stage">{stages[stageIndex]}</p>
      <p className="ml-hint">
        {mode === 'transcription'
          ? 'First load takes 15–20 seconds. Subsequent uses are instant.'
          : 'Applying your keywords — first load takes 15–20 seconds.'}
      </p>
    </div>
  );
}

export default ModelLoader;
